<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2><span class="display-1 font-weight-light">Staff</span>
      <v-switch style="position:absolute; right:15px" class="mt-0 d-inline-flex" v-model="status" :true-value="'active'"
                :false-value="null" :label="getLabelForStatusSwitch"></v-switch>
    </h2>
    <v-flex>
      <v-data-table
        id="staffTable"
        :items="tableData"
        :item-class="inactiveMember"
        :headers="tableHeader"
        :items-per-page="25"
        :server-items-length="totalItems"
        :options.sync="options"
        :loading="loading"
        :footer-props="footerProps"
        @update:page="firePageUpdated"
        @update:items-per-page="fireItemsPerPageUpdated"
        @update:sort-by="fireSortByUpdated"
        @update:sort-desc="fireSortDescUpdated"
      >
        <template v-slot:item.starred="{item}">
          <starred-profile :id="item._id" :starred="item.starred"
                           @profile-starred="updateStarred($event.id, $event.starred)"></starred-profile>
        </template>
        <template v-slot:item.scrapedProfile.summary.name="{item}">
          <router-link
            :to="{name: 'staffDetail', params: {id: item._id}}"
            class=""
            :tag="item.conflictOtherProfile ? 'button': 'a'"
            :disabled="item.conflictOtherProfile"
          >
            <div v-if="item.scrapedProfile && !item.scrapedProfile.meta.profileNotFound" class="d-inline-block">
              <v-avatar class="my-2 mx-2" color="grey lighten-2">
                <v-img :src="item.scrapedProfile.summary.publicProfilePicture"></v-img>
              </v-avatar>
              {{item.scrapedProfile.summary.name}}
              <v-tooltip top v-if="useBranding && profileNotWorkingInCompany(item.scrapedProfile.summary.company)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" v-bind="attrs"
                          v-on="on" class="pointer">mdi-cards
                  </v-icon>
                </template>
                <span>The main company in summary is not {{clientName}}</span>
              </v-tooltip>
            </div>
            <div v-else class="d-inline-block">
              <v-avatar class="my-2 mx-2" color="error lighten-1">
              </v-avatar>
              {{item.name}}
              <v-tooltip top v-if="item.scrapedProfile && item.scrapedProfile.meta.profileNotFound">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" v-bind="attrs"
                          v-on="on" class="pointer">mdi-lock
                  </v-icon>
                </template>
                <span>Profile not public</span>
              </v-tooltip>
            </div>
            <div v-if="item.conflictOtherProfile" class="d-inline-block">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs"
                          v-on="on" class="pointer">mdi-lock-alert
                  </v-icon>
                </template>
                <span>Protected profile: staff member of our customers will always be protected</span>
              </v-tooltip>
            </div>
          </router-link>
        </template>
        <template v-slot:item.keyword="{item}">
          {{ getPosition(item) }}
        </template>
        <!--<template v-slot:item.url="{item}">
          <a style="text-decoration: none" :href="item.url" target="_blank">
            <v-btn icon class="primary&#45;&#45;text">
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </a>
        </template>
        <template v-slot:item.edit="{item}">
          <edit-profile :profile-id="item._id"></edit-profile>
        </template>-->
        <!--        <template v-slot:item.kpis.avgChanges="{item}">-->
        <!--          <span class="subtitle-2">{{item.edges.market.avgProfileChanges}}</span>-->
        <!--        </template>-->
        <template v-slot:item.edges.engagement.total.value="{item}">
          <v-chip small label
                  v-if="item.scrapedProfile && item.edges.engagement && item.edges.engagement.total"
                  :color="getColor(item.edges.engagement.total.value)">
            {{item.edges.engagement.total.label}}
          </v-chip>
          <span v-else>
            Not enough data
          </span>
        </template>
<!--        <template v-slot:item.kpis.trend="{item}">-->
<!--          <trend-changes :profile="item"-->
<!--                         v-if="item.scrapedProfile && item.edges.market.profileChangesCounters.length > 2"></trend-changes>-->
<!--          <span v-else>-->
<!--            Not enough data-->
<!--          </span>-->
<!--        </template>-->
        <template v-slot:item.kpis.newTrend="{item}">
          <trend-changes-new-algorithm :profile="item"
                         v-if="item.scrapedProfile && item.edges.market.profileChangesCounters.length > 2"></trend-changes-new-algorithm>
          <span v-else>
            Not enough data
          </span>
        </template>

<!--        Activity-->
        <template v-slot:item.edges.engagement.activity.value="{item}">
          <span v-if="item.scrapedProfile && item.edges.engagement && item.edges.engagement.activity"
            class="text-center mx-auto subtitle-1 mt-5"
            :class="getClass(item.edges.engagement.activity.value)">
            {{ item.edges.engagement.activity.label }}
          </span>
          <span v-else>
            Not enough data
          </span>
        </template>
<!--        Profile-->
        <template v-slot:item.edges.engagement.profile.value="{item}">
          <span v-if="item.scrapedProfile && item.edges.engagement && item.edges.engagement.profile"
                class="text-center mx-auto subtitle-1 mt-5"
                :class="getClass(item.edges.engagement.profile.value)">
            {{ item.edges.engagement.profile.label }}
          </span>
          <span v-else>
            Not enough data
          </span>
        </template>
<!--        Market-->
        <template v-slot:item.edges.engagement.market.value="{item}">
          <span v-if="hasSalary(item) && item.scrapedProfile && item.edges.engagement && item.edges.engagement.market"
                class="text-center mx-auto subtitle-1 mt-5"
                :class="getClass(item.edges.engagement.market.value)">
            {{ item.edges.engagement.market.label }}
          </span>
          <span v-else-if="hasSalary(item)" class="primary--text text-center mx-auto subtitle-1 mt-5">
            Computing...
          </span>
          <edit-profile class="mt-5" :profile-id="item._id" :IdTarget="'salary'" v-else >
            <v-btn small class="primary">
              <v-icon left small>
                mdi-pencil
              </v-icon>
              Add salary
            </v-btn>
          </edit-profile>
        </template>
<!--        <template v-slot:item.edges.market.profileCompletion="{item}">-->
<!--          <div v-if="item.scrapedProfile">-->
<!--            <span class="subtitle-2">{{getProfileCompletionPercentage(item.edges.market.profileCompletion)}}%</span>-->
<!--            <v-progress-linear :value="getProfileCompletionPercentage(item.edges.market.profileCompletion)" rounded>-->
<!--            </v-progress-linear>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            Not processed yet-->
<!--          </div>-->
<!--        </template>-->
<!--        <template v-slot:item.edges.market.currentChanges="{item}">-->
<!--          <show-diffs-->
<!--            :delta="getCurrentChanges(item)"-->
<!--            :left="getHistory(item.history, 1)"-->
<!--            :right="getHistory(item.history, 0)"-->
<!--            :totalChanges="getTotalChangesCurrent(item)"-->
<!--            v-if="item.history.length > 0"-->
<!--          ></show-diffs>-->
<!--        </template>-->
<!--        <template v-slot:item.edges.market.lastChanges="{item}">-->
<!--          <show-diffs-->
<!--            :delta="getLastChanges(item)"-->
<!--            :left="getHistory(item.history, 2)"-->
<!--            :right="getHistory(item.history, 1)"-->
<!--            :totalChanges="getTotalChangesLast(item)"-->
<!--          ></show-diffs>-->
<!--        </template>-->
<!--        <template v-slot:item.edges.jobs="{item}">-->
<!--          <increase-decrease-tooltip v-if="item.scrapedProfile"-->
<!--                                     :current-value="item.edges.jobs.totalJobOffersCurrentWeek"-->
<!--                                     :previous-value="item.edges.jobs.totalJobOffersPreviousWeek"-->
<!--          ></increase-decrease-tooltip>-->
<!--        </template>-->
        <template v-slot:item.actions="{item}">
          <profile-action-buttons :profile="item" :group="'staff'"></profile-action-buttons>
        </template>
      </v-data-table>
    </v-flex>
  </v-container>
</template>

<script>
  import api from '@/api/index';
  import {mapEngagementColor, nonEmptyField} from "../../helpers/helpers";
  import {applySorting, buildFilters} from "../../helpers/table";
  import ShowDiffs from "../../components/Buttons/Profiles/showDiffs";
  import ProfileHeading from "../../components/Widgets/profileHeading";
  import TrendChanges from "../../components/Charts/Profile/trendChanges";
  import StarredProfile from "../../components/Buttons/Profiles/starredProfile";
  import ProfileActionButtons from "../../components/Widgets/profileActionButtons";
  import TrendChangesNewAlgorithm from "../../components/Charts/Profile/trendChangesNewAlgorithm";
  import EditProfile from "../../components/Buttons/Profiles/editProfile";

  const tableHeaders = [
    {text: 'Fav.', value: 'starred', width: 35, class:'px-1'},
    {text: 'Profile details', value: 'scrapedProfile.summary.name', 'width': 300},
    {text: 'Position', value: 'keyword'},
    // {text: 'Average changes', value: 'kpis.avgChanges', sortable: false},
    {text: 'Engagement', value: 'edges.engagement.total.value', width: 130},
    // {text: 'Engagement trend', value: 'kpis.trend', sortable: false, width: 225},
    {text: 'Engagement trend', value: 'kpis.newTrend', sortable: false, width: 225},
    {text: 'Activity', value: 'edges.engagement.activity.value'},
    {text: 'Profile', value: 'edges.engagement.profile.value'},
    {text: 'Market', value: 'edges.engagement.market.value'},
    // {text: 'Current updates', value: 'edges.market.currentChanges', sortable: false},
    // {text: 'Profile completion', value: 'edges.market.profileCompletion', sortable: false},
    // {text: 'Previous updates', value: 'edges.market.lastChanges', sortable: false},
    // {text: 'Job offers', value: 'edges.jobs', sortable: false},
    {text: 'Actions', value: 'actions', width: 175, sortable: false},
    // {text: 'Linkedin URL', value: 'url', width: 75, sortable: false},
    // {text: '', value: 'edit', width: 40, sortable: false},
  ];

  export default {
    name: "List",
    components: {
      EditProfile,
      TrendChangesNewAlgorithm,
      ProfileActionButtons,
      StarredProfile, TrendChanges, ProfileHeading, ShowDiffs
    },
    data() {
      return {
        filters: [],
        rules: {
          nonEmpty: nonEmptyField
        },
        searchTerm: '',
        loading: true,
        options: {
          page: 1,
          sortBy: ['edges.engagement.total.value'],
          sortDesc: [true]
        },
        footerProps: {
          'items-per-page-options': [5, 10, 25, 100]
        },
        tableData: [],
        totalItems: 0,
        tableHeader: tableHeaders,
        status: 'active'
      }
    },
    watch: {
      options: {
        handler() {
          this.search();
        },
        //deep: true,
      },
      status: {
        handler() {
          this.resetPage();
        }
      }
    },
    mounted() {
      //this.search();
      // this.loadAvailableFilters();
    },
    computed: {
      useBranding() {
        return this.$store.getters.getSettingsFromToken.branding;
      },
      clientName() {
        return this.$store.getters.getSettingsFromToken.completeName;
      },
      getLabelForStatusSwitch() {
        return this.status ? 'Showing only current employees' : 'Showing all members';
      }
    },
    methods: {
      getColor(value){
        return mapEngagementColor(value);
      },
      getClass(value){
        return mapEngagementColor(value)+'--text';
      },
      inactiveMember(item) {
        return item.status === 'inactive' ? 'bg-inactive' : '';
      },
      profileNotWorkingInCompany(company) {
        if (company) {
          const clientName = this.$store.getters.getSettingsFromToken.completeName.toLowerCase();
          const companyName = company.name.toLowerCase();
          return clientName !== companyName && clientName.indexOf(companyName) < 0 && companyName.indexOf(clientName);
        }
        return false;
      },
      getTotalChangesCurrent(item) {
        let length = item.edges.market.profileChangesCounters.length;
        return item.edges.market.profileChangesCounters[length - 1];
      },
      getTotalChangesLast(item) {
        let length = item.edges.market.profileChangesCounters.length;
        return length > 1 ? item.edges.market.profileChangesCounters[length - 2] : 0;
      },
      getCurrentChanges(item) {
        return item.edges.market.profileChanges[0];
      },
      getLastChanges(item) {
        let length = item.edges.market.profileChanges.length;
        return length > 1 ? item.edges.market.profileChanges[1] : {};
      },
      getHistory(history, current = 0) {
        let historyCp = JSON.parse(JSON.stringify(history));
        historyCp = applySorting(['scrapedDate'], [true], historyCp);
        return (current > history.length) ? {} : historyCp[current];
      },
      getProfileCompletionPercentage(profileCompletion) {
        let profileCompletionObject = JSON.parse(JSON.stringify(profileCompletion));
        delete profileCompletionObject.total;
        delete profileCompletionObject.scrapedDate;
        const len = Object.keys(profileCompletionObject).length;
        return Math.round(profileCompletion.total / len);
      },
      resetPage() {
        // this.$ga.event('Staff', 'search');
        this.$gtag.event('search', {
          event_category: 'Staff'
        });
        if (this.options.page === 1) {
          this.search();
        } else {
          this.options.page = 1;
        }
      },
      search() {
        this.loading = true;
        let filters = buildFilters(this.filters);

        let viewFilters = {
          groups: {$in: ['staff']}
        };
        if (this.status) {
          viewFilters.status = this.status;
        }

        const {sortBy, sortDesc} = this.options;
        api.members.getProfilesWithChanges({
          filters,
          viewFilters,
          options: this.options
        }).then(
          response => {
            this.loading = false;
            this.tableData = applySorting(sortBy, sortDesc, response.data.data.profiles);
            this.totalItems = response.data.data.profilesCount;
            if (!this.checkDrawTrend(this.tableData)) {
              this.tableHeader = this.tableHeader.filter(e => e.value !== 'kpis.trend')
            }
          })
      },
      getPosition(item) {
        return item.jobSearchTerms.length > 0 && item.jobSearchTerms[0].jobKeywordName ? item.jobSearchTerms[0].jobKeywordName : item.keyword;
      },
      checkDrawTrend(profiles) {
        const arr = profiles.map(e => e.edges ? e.edges.market.profileChangesCounters.length : 0);
        return Math.max(...arr) > 3;
      },
      firePageUpdated(page) {
        // this.$ga.event('Staff', 'change datatable option', 'page - ' + page);
        this.$gtag.event('change datatable option', {
          event_category: 'Staff',
          event_label: 'page - ' + page
        });
      },
      fireItemsPerPageUpdated(ItemsPerPage) {
        // this.$ga.event('Staff', 'change datatable option', 'items per page - ' + ItemsPerPage);
        this.$gtag.event('change datatable option', {
          event_category: 'Staff',
          event_label: 'items per page - ' + ItemsPerPage
        });
      },
      fireSortByUpdated(sortBy) {
        // this.$ga.event('Staff', 'change datatable option', 'sort by - ' + sortBy);
        this.$gtag.event('change datatable option', {
          event_category: 'Staff',
          event_label: 'sort by - ' + sortBy
        });
      },
      fireSortDescUpdated(sortDesc) {
        // this.$ga.event('Staff', 'change datatable option', 'sort desc - ' + sortDesc);
        this.$gtag.event('change datatable option', {
          event_category: 'Staff',
          event_label: 'sort desc - ' + sortDesc
        });
      },
      updateStarred(id, starred) {
        // this.$ga.event('Staff', 'profile starred', `starred ${starred} ${id}`);
        this.$gtag.event('profile starred', {
          event_category: 'Staff',
          event_label: `starred ${starred} ${id}`
        });
        let profile = this.tableData.find(el => el._id === id);
        this.$set(profile, 'starred', starred)
      },
      hasSalary(item) {
        return item.salary && item.salary.length > 0 && item.salary[0].baseSalaryRange &&
          (item.salary[0].baseSalaryRange.max > 0 || (item.salary[0].baseSalaryRange.max === null && item.salary[0].baseSalaryRange.min > 0));
      }
    },
  }
</script>

<style scoped>
  /*pre {*/
  /*  white-space: pre-wrap;*/
  /*  font-size: 0.6em;*/
  /*}*/

  .mw-10 {
    max-width: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/staff/List.vue